/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { ForwardedRef, forwardRef, useState } from "react";
import s from "./RangeSlider.module.css";

interface IRangeSliderProps extends React.HTMLProps<HTMLInputElement> {
  className?: string;
  viewValue?: boolean;
}

const RangeSlider = forwardRef(
  (
    { className, viewValue = true, ...args }: IRangeSliderProps,
    ref: ForwardedRef<HTMLInputElement | null>
  ) => {
    const [value, setValue] = useState(() => {
      let val;
      if (args.value) {
        val = args.value;
      } else if (args.defaultValue) {
        val = args.defaultValue;
      } else {
        val = "0";
      }
      return val;
    });

    return (
      <div className="relative w-full" test-id="nZafX5rG">
        <input
          type="range"
          ref={ref}
          onChange={(e) => setValue(e.target.value)}
          className={cn(s.root, className, "w-full")}
          {...args}
          test-id="irB0vQYn"
        />
        {viewValue ? value : null}
      </div>
    );
  }
);

export default RangeSlider;
